import React, { useContext } from "react";
import useScreenSize from "../../hooks/useScreenSize";
import { WhmButton, whmTheme } from "@securitize/reactjs-whm";
import WhmLegacyIcon from "../shared/WhmLegacyIcon";
import { I18nContext, translationKeys } from "../../contexts/I18nContext";

function FundHoldingsDownloadButton({
  onDownload,
}: {
  onDownload: () => void;
}) {
  const { getTranslation } = useContext(I18nContext);
  const { isSmall, isMedium } = useScreenSize();
  const isMobile = isSmall || isMedium;
  return (
    <WhmButton
      variant={isMobile ? "outlined" : "text"}
      color="primary"
      startIcon={
        <WhmLegacyIcon
          icon="download"
          sx={{
            color: whmTheme.palette.primary.main,
            width: "20px",
            height: "20px",
          }}
        />
      }
      sx={{
        width: {
          xs: "100%",
          sm: "100%",
          md: "auto",
        },
      }}
      onClick={onDownload}
    >
      {getTranslation(translationKeys.TEXT_HOLDINGS_TABLE_DOWNLOAD_BUTTON)}
    </WhmButton>
  );
}

export default FundHoldingsDownloadButton;
